import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AppMenuItemComponent } from './app-menu-item/app-menu-item.component';
import { AppMenuCentralComponent } from './app-menu-central/app-menu-central.component';
import { MenuAiActionsToastComponent } from '../../@toasts/menu-ai-actions-toast/menu-ai-actions-toast.component';
import { HomeIconComponent } from '../../../@icons/home-icon.component';
import { GardenIconComponent } from '../../../@icons/garden-icon.component';
import { AccountIconComponent } from '../../../@icons/account-icon.component';
import { CalendarClockIconComponent } from '../../../@icons/calendar-clock-icon.component';
import { WebViewBridgeService } from '../../@services/webview/webview-bridge.service';
import { WebViewAction } from '../../enums/webview-action';
import { SafeAreaService } from '../../@services/webview/safe-area.service';
import { WillyChatService } from '../../@services/front/willy-chat.service';


@Component({
  selector: 'vw-app-menu',
  imports: [
    SharedModule,
    CommonModule,
    TranslatePipe,
    AppMenuItemComponent,
    AppMenuCentralComponent,
    MenuAiActionsToastComponent,
    HomeIconComponent,
    GardenIconComponent,
    AccountIconComponent,
    CalendarClockIconComponent,

  ],
  templateUrl: './app-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app-menu.component.scss'
})
export class AppMenuComponent {
  @Input() currentScreen: string = 'home';
  @Output() screenChange = new EventEmitter<string>();

  isAIModalOpen: boolean = false;
  inputIsFocus: boolean = false;

  safeAreaBottom: number = 32;

  constructor(private router: Router, private webViewBridgeService: WebViewBridgeService, private safeAreaService: SafeAreaService,
    private willyChatService: WillyChatService) {
    // Écoute les événements de navigation pour mettre à jour `currentScreen`
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isAIModalOpen = false;
        this.currentScreen = this.extractScreenName(event.url);

        // Ouverture différée demandée depuis un écran sans menu (ex. « Diagnostiquer
        // cette plante » sur le détail d'une plante) : on ouvre puis on injecte le
        // pré-remplissage une fois le chatbot monté (timeout → après ce cycle de rendu).
        const pendingPrefill = this.willyChatService.takePendingOpen();
        if (pendingPrefill !== null) {
          this.isAIModalOpen = true;
          setTimeout(() => this.willyChatService.openChat(pendingPrefill), 0);
        }
      }
    });
    this.safeAreaService.safeAreaData$.subscribe((data) => {
      this.safeAreaBottom = data.bottom || 32;
    });
    // Open the AI chat when requested from elsewhere (e.g. "Diagnose this plant")
    this.willyChatService.openChat$.subscribe(() => {
      this.isAIModalOpen = true;
    });
  }

  /**
   * Extrait le nom de l'écran depuis l'URL de navigation.
   * @param url - L'URL complète.
   * @returns Le nom de l'écran.
   */
  private extractScreenName(url: string): string {
    const segments = url.split('/').filter((s) => s.length > 0);
    return segments.length > 0 ? segments[0] : 'home'; // Exemple : '/profile' → 'profile'
  }

  changeScreen(screen: string) {
    this.router.navigate([`/${screen}`]); // Navigation via le Router
    this.isAIModalOpen = false;
  }

  onClickProfile() {
    this.changeScreen('profile');
  }

  openAIPopup() {
    this.webViewBridgeService.postMessageToChannel(WebViewAction.vibration, 'true');
    this.isAIModalOpen = !this.isAIModalOpen;
  }

  onAIModalClosed() {
    this.isAIModalOpen = false;
  }

  onInputFocus() {
    this.inputIsFocus = true;
  }

  onInputBlur() {
    this.inputIsFocus = false;
  }
}
